export type VillageTab = 'classes' | 'courts';

/**
 * The navigation contract between the home page and the Fitness Village page.
 *
 * The page reads `companyId`, `branchId` and `tab` from the query string (see
 * `useFitnessVillagePage`'s `VILLAGE_PARAMS`), so these three are the whole handshake:
 * every other parameter the page understands has a documented fallback. A village is a branch.
 *
 * Pure and exported so the exact shape is unit-tested rather than asserted by eye.
 */
export const buildVillageUrl = (companyId: string, branchId: string, tab: VillageTab): string =>
  `/FitnessVillage?companyId=${companyId}&branchId=${branchId}&tab=${tab}`;
